import { EMPTY, of, concat } from 'rxjs';
import { mergeMap, filter, take, takeUntil } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';
import { BulkActionService } from '../../../services/bulk-action-service';
import { shipstationConnect } from '../../../services/shipstation-connect/';
import { convertReadScaleResponse$ } from '../../shipstation-connect/ss-connect.observables';

import Global from '../../../store/global-selectors';

import * as Actions from './bulk.update.actions';

export const bulkUpdateJobDeleted$ = (action$, bulkUpdateJobId) => {
  return action$.pipe(
    filter((action) => {
      return action.type === Actions.DELETE_BULK_UPDATE_JOB && action.bulkUpdateJobId === bulkUpdateJobId;
    }),
    take(1),
  );
};

export const setConfirmationTypes$ = (bulkUpdateJobId, model, getState) => {
  const state = getState();
  const serviceId = get(model, 'shippingConfiguration.serviceId', '');
  const selectedService = Global.selectSellerServiceById(state, { serviceId });
  const selectedCarrierId = get(selectedService, 'carrierId', '');
  const carrierIdInState = Global.selectBulkUpdateDrawerBulkUpdateProperty(state, { property: 'carrierId' });
  const isNewCarrierSelected = selectedCarrierId !== carrierIdInState;
  if (isNewCarrierSelected) {
    const carriers = Global.selectReferenceDatagetSellerCarriers(state);
    const carrierInfo = carriers.find((carrier) => carrier.carrierId === selectedCarrierId);
    const confirmationTypes = get(carrierInfo, 'confirmations', emptyArray) || emptyArray;
    return of(Actions.setCarrierAndConfirmationTypes(bulkUpdateJobId, selectedCarrierId, confirmationTypes));
  }
  return EMPTY;
};

export const onSetModel$ = (action$, getState, bulkUpdateJobId) => {
  return action$.pipe(
    filter((action) => {
      return action.type === Actions.BULK_UPDATE_SET_MODEL && action.bulkUpdateJobId === bulkUpdateJobId;
    }),
    mergeMap((action) => setConfirmationTypes$(bulkUpdateJobId, action.model, getState)),
    takeUntil(bulkUpdateJobDeleted$(action$, bulkUpdateJobId)),
  );
};

export const onChangeModel$ = (action$, getState, bulkUpdateJobId) => {
  return action$.pipe(
    ofType(Actions.BULK_UPDATE_CHANGE_MODEL),
    mergeMap((action) => {
      const state = getState();
      const { model, bulkActions } = Global.selectBulkUpdateBulkUpdateJob(state, { bulkUpdateJobId: action.bulkUpdateJobId });
      const newModel = {
        ...model,
        ...action.modelUpdate,
      };
      newModel.errors = BulkActionService.getModelErrors(bulkActions, newModel);
      return concat(of(Actions.setModel(action.bulkUpdateJobId, newModel)), setConfirmationTypes$(bulkUpdateJobId, newModel, getState));
    }),
    takeUntil(bulkUpdateJobDeleted$(action$, bulkUpdateJobId)),
  );
};

export const bulkUpdateReadScaleRequest$ = (action$, getState, bulkUpdateJobId) => {
  return action$.pipe(
    ofType(Actions.BULK_UPDATE_READ_SCALE_REQUEST),
    mergeMap(({ scale, requestId }) => {
      shipstationConnect.readFromScale(scale, requestId);
      return convertReadScaleResponse$(action$, getState, scale.workstationId);
    }),
    takeUntil(bulkUpdateJobDeleted$(action$, bulkUpdateJobId)),
  );
};
